import React, { useState } from "react";
import Layout from "../components/Layout";
import { useNavigate, useParams } from "react-router-dom";

import { getTeamModules, addTeamModules } from "./../actions/form";
import { connect } from "react-redux";

const ModulesSelect = ({ getTeamModules, addTeamModules }) => {
  // const team = "5 to 7 people";

  const { team } = useParams();

  const navigate = useNavigate();

  const [modules, _] = useState([
    {
      name: "Astronomy",
      type: "Natural Sciences",
    },
    {
      name: "Biology",
      type: "Natural Sciences",
    },
    {
      name: "Chemistry",
      type: "Natural Sciences",
    },
    {
      name: "Riyaziat",
      type: "Natural Sciences",
    },
    {
      name: "Construction",
      type: "Engineering",
    },
    {
      name: "Electric",
      type: "Engineering",
    },
    {
      name: "Robotics",
      type: "Engineering",
    },
    {
      name: "Ecolution",
      type: "General",
    },
    {
      name: "Kryptos",
      type: "General",
    },
    {
      name: "CSI",
      type: "General",
    },
    {
      name: "Multiverse",
      type: "General",
    },
  ]);

  const [formData, setFormData] = useState({
    naturalScience: "",
    engineering: "",
    general: "",
    extra1: "",
    extra2: "",
  });

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const result = await addTeamModules(formData);

    if (result) {
      navigate("/emailSent");
    }
  };

  return (
    <Layout>
      <div class="slider-area">
        <div class="single-slider hero-overly slider-height2 slider-bg2 d-flex align-items-center">
          <div class="container">
            <div class="row justify-content-center ">
              <div class="col-xxl-12">
                <div class="hero-caption hero-caption2">
                  <h2>Registration - Science Olmpiad</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="container p-4 pt-0 mt-0">
        <form
          className="form-contact contact_form"
          onSubmit={(e) => onSubmit(e)}
        >
          <h1 className="text-light">Modules Select</h1>

          <div className="row">
            <div className="col">
              <br />
              <h2 className="text-light">Natural Sciences</h2>
              <br />
              <div id="naturalScience">
                <div className="form-group d-flex">
                  <select
                    className="form-control"
                    name="naturalScience"
                    onChange={(e) => onChange(e)}
                    required
                  >
                    <option value="">Select module</option>
                    {modules
                      .filter((module) => module.type === "Natural Sciences")
                      .map((module) => (
                        <option value={module.name}>{module.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col">
              <br />
              <h2 className="text-light">Engineering</h2>
              <br />
              <div id="engineering">
                <div className="form-group d-flex">
                  <select
                    className="form-control"
                    required
                    name="engineering"
                    onChange={(e) => onChange(e)}
                  >
                    <option value="">Select module</option>
                    {modules
                      .filter((module) => module.type === "Engineering")
                      .map((module) => (
                        <option value={module.name}>{module.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col">
              <br />
              <h2 className="text-light">General</h2>
              <br />
              <div id="general">
                <div className="form-group d-flex">
                  <select
                    className="form-control"
                    name="general"
                    onChange={(e) => onChange(e)}
                    required
                  >
                    <option value="">Select module</option>
                    {modules
                      .filter((module) => module.type === "General")
                      .map((module) => (
                        <option value={module.name}>{module.name}</option>
                      ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          {team === "5 to 7 people" && (
            <div className="row">
              <br />
              <h2 className="text-light">Others</h2>
              <br />
              <div className="col">
                <div id="other1">
                  <div className="form-group d-flex">
                    <select
                      className="form-control"
                      name="extra1"
                      onChange={(e) => onChange(e)}
                      required
                    >
                      <option value="">Select module</option>
                      {modules
                        .filter(
                          (module) =>
                            ![
                              formData.engineering,
                              formData.naturalScience,
                              formData.extra2,
                              formData.general,
                            ].includes(module.name)
                        )
                        .map((module) => (
                          <option value={module.name}>{module.name}</option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="col">
                <div id="other2">
                  <div className="form-group d-flex">
                    <select
                      className="form-control"
                      name="extra2"
                      onChange={(e) => onChange(e)}
                      required
                    >
                      <option value="">Select module</option>
                      {modules
                        .filter(
                          (module) =>
                            ![
                              formData.engineering,
                              formData.naturalScience,
                              formData.extra1,
                              formData.general,
                            ].includes(module.name)
                        )
                        .map((module) => (
                          <option value={module.name}>{module.name}</option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="form-group mt-3">
            <button
              type="submit"
              className="button button-contactForm btn_1 w-100"
            >
              Next
            </button>
          </div>

          {team === "5 to 7 people" && <></>}
        </form>
      </section>
    </Layout>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { addTeamModules, getTeamModules })(
  ModulesSelect
);
